import BingAdsAppDrawer from './BingAdsAppDrawer';

const drawers = [BingAdsAppDrawer];

export default drawers;
